import React, { useRef } from "react";
import moment from "moment";
import { compose } from "recompose";
import { connect } from "react-redux";

import { connectToApi, ApiConnectedOwnProps } from "@api/components/connectToApi";
import { Api } from "@api/index";
import { LocalisationState } from "@localisation/models";
import { OldWataState } from "../../models";
import {
    getUrl,
    getLastLoaded,
    getLoggedOutAt,
    getIframeHeight,
} from "../../selectors";

interface IframeStateProps {
    src: string;
    height: number;
}

interface IframeOwnProps {
    path: string;
}

type Props = IframeStateProps & ApiConnectedOwnProps;

const Iframe = ({ src, height }: Props) => {
    const ref = useRef(null);
    return (
        <div className="old-wata-iframe">
            {src &&
                <iframe
                    ref={ref}
                    src={src}
                    width="100%" height={height}
                />
            }
        </div>
    );
};

const makeOldwataRoute = (path: string) => () => Api.oldwataRoute(path);

const mapStateToProps = (state: OldWataState & LocalisationState, props: IframeOwnProps) => {
    // Force a refresh on log out
    let requestId = "initial";
    const loggedOutAt = getLoggedOutAt(state);
    if (loggedOutAt != null) {
        requestId = moment(loggedOutAt).format();
    }
    return {
        src: getUrl(state, props),
        actionCreators: [makeOldwataRoute(props.path)],
        lastLoaded: [getLastLoaded(state)],
        requestId: [requestId],
        height: getIframeHeight(state),
    } as Props;
};

const ConnectedIframe = compose<Props, IframeOwnProps>(
    connect(mapStateToProps, null),
    connectToApi({
        showRefresh: false,
    }),
)(Iframe);

export {
    Iframe as IframePresenter,
    ConnectedIframe as Iframe,
    IframeOwnProps as IframeProps,
};
